module.exports = __webpack_public_path__ + "57caf92a4628bdd3216a410c71fb3832.svg";